import { ITooltipHostProps, TooltipDelay, TooltipHost } from '@fluentui/react';

export interface IPTooltipHostProps extends ITooltipHostProps {}
export { TooltipDelay as IPTooltipDelay };

export const IPTooltipHost = (props: IPTooltipHostProps) => {
  return <TooltipHost {...props} />;
};
